export default {"src":"/pro/_next/static/media/atom.cfc50dab.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};